module.exports = __webpack_public_path__ + "img/5.15c97f7a.png";